"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerAccountProvider = void 0;
const react_1 = __importStar(require("react"));
const customerAccountContext_1 = require("./customerAccountContext");
const useLocalStorage_1 = require("../hooks/useLocalStorage");
var CustomerGroup;
(function (CustomerGroup) {
    CustomerGroup[CustomerGroup["FIFTEEN_PERC_DISCOUNT"] = 6] = "FIFTEEN_PERC_DISCOUNT";
    CustomerGroup[CustomerGroup["TWENTY_PERC_DISCOUNT"] = 7] = "TWENTY_PERC_DISCOUNT";
    CustomerGroup[CustomerGroup["DEFAULT"] = 0] = "DEFAULT";
})(CustomerGroup || (CustomerGroup = {}));
const CustomerAccountProvider = ({ children, boutikService, apolloClient, customerAccountActions, }) => {
    const { isAuthenticated, assertNotAuthenticated } = boutikService;
    const profile = customerAccountActions.user.profileHook(isAuthenticated);
    const [customerProfile, setCustomerProfile] = (0, useLocalStorage_1.useLocalStorage)("CustomerAccount:customerProfile");
    const [store, setStore] = (0, react_1.useState)("none");
    const [language, setLanguage] = (0, react_1.useState)("");
    const [customerId, setCustomerId] = (0, react_1.useState)("");
    const [proDiscount, setProDiscount] = (0, react_1.useState)(0);
    const [isProEnabled, setIsPro] = (0, react_1.useState)(false);
    const updateIsProEnabled = (0, react_1.useCallback)((newState) => {
        setIsPro(newState);
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        const storedIsProEnabled = localStorage.getItem("isProEnabled");
        const storedProDiscount = parseInt((_a = localStorage.getItem("proDiscount")) !== null && _a !== void 0 ? _a : "0");
        setIsPro(storedIsProEnabled ? JSON.parse(storedIsProEnabled) : false);
        setProDiscount(storedProDiscount ? storedProDiscount : 0);
    }, []);
    (0, react_1.useEffect)(() => {
        localStorage.setItem("isProEnabled", JSON.stringify(isProEnabled));
        localStorage.setItem("proDiscount", proDiscount.toString());
    }, [isProEnabled, proDiscount]);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        const userProfileData = (_a = profile === null || profile === void 0 ? void 0 : profile[1]) === null || _a === void 0 ? void 0 : _a.data;
        if (userProfileData) {
            const extra_attributes = (_b = userProfileData === null || userProfileData === void 0 ? void 0 : userProfileData.customer) === null || _b === void 0 ? void 0 : _b.extra_attributes;
            let jsonBrands = [];
            if (extra_attributes) {
                const brands = JSON.parse(extra_attributes);
                const brandsObject = brands.brands[0];
                jsonBrands = brandsObject.split(";").map((brand) => {
                    return brand;
                });
            }
            const newCustomerProfile = {
                email: userProfileData.customer.email || "",
                inventoryEmail: userProfileData.customer.inventoryEmail,
                firstname: userProfileData.customer.firstname || "",
                lastname: userProfileData.customer.lastname || "",
                isSubscribed: userProfileData.customer.isSubscribed || false,
                isPro: ((_c = userProfileData === null || userProfileData === void 0 ? void 0 : userProfileData.customer) === null || _c === void 0 ? void 0 : _c.extra_attributes) ? true : false,
                isProEnabled: isProEnabled,
                extra_attributes: jsonBrands,
                proDiscount,
                store: store,
                lang: language,
                addresses: [],
            };
            if (JSON.stringify(customerProfile) !== JSON.stringify(newCustomerProfile)) {
                setCustomerProfile(newCustomerProfile);
            }
        }
    }, [profile, isProEnabled, proDiscount, store, language, customerId]);
    const clearCustomerProfile = () => {
        assertNotAuthenticated();
        setCustomerProfile(undefined);
        apolloClient.cache.reset();
    };
    (0, react_1.useEffect)(() => {
        if (!isAuthenticated && customerProfile) {
            clearCustomerProfile();
        }
        if (isAuthenticated && customerId == "") {
            getMagentoCurrentCustomerData(boutikService)
                .then((data) => {
                if (data) {
                    const createdInArray = data.created_in.split(" ");
                    const country = createdInArray[2];
                    const language = createdInArray[1].toLowerCase();
                    setCustomerId(data.id);
                    setStore(country === "US" ? country : "CA");
                    setLanguage(language.includes("fr") ? `fr_${country}` : `en_${country}`);
                    setProDiscount((data === null || data === void 0 ? void 0 : data.group_id) === CustomerGroup.FIFTEEN_PERC_DISCOUNT ? 15 : (data === null || data === void 0 ? void 0 : data.group_id) === CustomerGroup.TWENTY_PERC_DISCOUNT ? 20 : 0);
                }
            })
                .catch((error) => console.log(error));
        }
    }, [isAuthenticated, customerId]);
    const contextValue = {
        currentUser: customerProfile,
        customerId: customerId,
        isIdentified: customerProfile !== undefined,
        clearCustomerProfile,
        actions: customerAccountActions,
        updateIsProEnabled,
    };
    return react_1.default.createElement(customerAccountContext_1.CustomerAccountContext.Provider, { value: contextValue }, children);
};
exports.CustomerAccountProvider = CustomerAccountProvider;
function getMagentoCurrentCustomerData(boutikServiceContext) {
    return __awaiter(this, void 0, void 0, function* () {
        const { boutikService, isAuthenticated } = boutikServiceContext;
        if (!boutikService.storeViewCode || !boutikService.accessToken || !isAuthenticated)
            return Promise.resolve(null);
        const url = `/rest/${boutikService.storeViewCode}/V1/customers/me`;
        const response = yield fetch(url, {
            method: "get",
            headers: {
                Authorization: `Bearer ${boutikService.accessToken}`,
                "Content-Type": "application/json",
            },
        });
        if (response.status !== 200) {
            console.error(`Magento ${url} call failed`, response);
            throw new Error(`Magento ${url} call failed`);
        }
        const data = yield response.json();
        return data;
    });
}
//# sourceMappingURL=CustomerAccountProvider.js.map